import { render } from "./reference.vue?vue&type=template&id=aef0ce0c&scoped=true"
const script = {}

import "./reference.vue?vue&type=style&index=0&id=aef0ce0c&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef0ce0c"]])

export default __exports__